import { motion } from "framer-motion";

const lineVariants = {
  hidden: { y: "110%" },
  visible: (i) => ({
    y: 0,
    transition: { duration: 0.9, delay: 0.15 + i * 0.12, ease: [0.16, 1, 0.3, 1] },
  }),
};

// Splits given lines into masked, kinetic reveal-on-load lines.
export function KineticLines({ lines, className = "", highlightIndex = null, highlightClassName = "text-[#00F0FF]" }) {
  return (
    <span className={className}>
      {lines.map((line, i) => (
        <span key={i} className="block overflow-hidden">
          <motion.span
            className={`block ${i === highlightIndex ? highlightClassName : ""}`}
            custom={i}
            initial="hidden"
            animate="visible"
            variants={lineVariants}
          >
            {line}
          </motion.span>
        </span>
      ))}
    </span>
  );
}

export function RevealOnScroll({ children, delay = 0, className = "", y = 28, ...rest }) {
  return (
    <motion.div
      className={className}
      initial={{ opacity: 0, y }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true, margin: "-80px" }}
      transition={{ duration: 0.7, delay, ease: [0.16, 1, 0.3, 1] }}
      {...rest}
    >
      {children}
    </motion.div>
  );
}
